/**Item corresponds to an item in an Outfit 
 * TODO: separate item into audit page item and browse audted item components (instead of using enableReEdit flag property)
*/
import React from 'react';
import {Multiselect} from 'AWS-UI-Components-React';
import '../styles/item.css' 

const green = '#39D1B4';
const red = '#ff0000';

const options = [
  {
    "label": "Product Guidelines",
    "options": [
      {
        "label": "Egregious Product",
        "id": "Egregious Product"
      },
      {
        "label": "Sets",
        "id": "Sets"
      },
      {
        "label": "Non-Standard Size",
        "id": "Non-Standard Size"
      },
      {
        "label": "Contradicting Occasions - extreme",
        "id": "Contradicting Occasions"
      },
      {
        "label": "Opposite Seasons - extreme",
        "id": "Opposite Seasons"
      },
      {
        "label": "Style Not Compatible - extreme",
        "id": "Style Not Compatible"
      },
      {
        "label": "Not Front Facing",
        "id": "Not Front Facing"
      },
      {
        "label": "Novelty/Costume/Seasonal/Cultural",
        "id": "Novelty/Costume/Seasonal/Cultural"
      },
      {
        "label": "On-Figure",
        "id": "On-Figure"
      },
      {
        "label": "Packaging",
        "id": "Packaging"
      }
    ]
  },
  {
    "label": "Image Guidelines",
    "options": [
      {
        "label": "Black Shadow",
        "id": "Black Shadow"
      },
      {
        "label": "Blurred/Distorted",
        "id": "Blurred Face"
      },
      {
       "label": "Extra Graphics/Text",
        "id": "Extra Graphics/Text"
      },
      {
        "label": "Multi-view",
        "id": "Multi-view"
      },
      {
        "label": "Non-White Background",
        "id": "Non-White Background"
      },
      {
        "label": "Partial/Cropped View",
        "id": "Partial/Cropped View"
      }
    ]
  },
  {
    "label": "Tool Guidelines",
    "options": [
      {
        "label": "Error Loading",
        "id": "Error Loading"
      },
      {
        "label": "Incorrect Categorization",
        "id": "Incorrect Categorization"
      }
    ]
  }
]

const seedOptions = [
  {
    "label": "Product Guidelines",
    "options": [
      {
        "label": "Egregious Product",
        "id": "Egregious Product"
      },
      {
        "label": "Sets",
        "id": "Sets"
      },
      {
        "label": "Luxury On-Figure",
        "id": "On-Figure"
      },
      {
        "label": "Novelty/Costume/Seasonal/Cultural",
        "id": "Novelty/Costume/Seasonal/Cultural"
      }
    ]
  },
  options[2]
]

export class Item extends React.Component{
  constructor(props){
    super(props);
    this.state = { 
      color: this.props.item.audit_status == "Rejected" ? red : green,
      isSeedCategory: this.props.seedCategory == this.props.item.category,
      selectedOptions:[],
      edited: false,
     };
    this.originalStatus = this.props.originalItem.audit_status;
    this.changeStatus = this.changeStatus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.handleStoreAudit = this.handleStoreAudit.bind(this);
    this.displayAsin = this.displayAsin.bind(this);
    this.displayEdited = this.displayEdited.bind(this);
  }

  componentDidMount() {
    if (this.props.enableReEdit) {
      var originalRejectionReasons = []
      for (let i = 0; i < this.props.item.rejection_reason_list.length; i++) {
        for (let j = 0; j < options.length; j++) {
          for (let k = 0; k < options[j].options.length; k++) {
            if (this.props.item.rejection_reason_list[i] === options[j].options[k].id) {
              originalRejectionReasons.push(options[j].options[k]);
            }
          }
        }
      }
      this.setState({selectedOptions:originalRejectionReasons})
    }
  }

  /**Changes audit_status based on whether user accepted or rejected item */
  handleStoreAudit(color) {
    const rejectionReasons = this.state.selectedOptions.length > 0 ? this.state.selectedOptions.map(x => x.id) : [];
    const statusString = color == green ? "Accepted" : "Rejected";
    const flag = color == red && rejectionReasons.length == 0;
    if (this.props.enableCollection) {
      this.props.storeAuditOutfit(statusString, flag, rejectionReasons, this.props.itemNum);
    } else {
      this.props.storeAuditOutfit(statusString, false, rejectionReasons, this.props.itemNum);
    }
  }

  /**Changes status of items based on clicks on the reject/accept outfit button*/
  actionsButton(status) {
    if (status != this.props.item.audit_status) {
      this.changeStatus([])
    }
  }

  /**Changes background color based on click => signifies accept/reject of individual item */
  changeStatus(options) {
    const newColor = this.state.color == green ? red : green;
    this.setState({ color: newColor, selectedOptions: options }, () => {
      this.handleStoreAudit(newColor)
    });
  }

  /**Passes on user selected options */
  handleChange(event) {
    this.setState({ selectedOptions: event.detail.selectedOptions }, () => {
      if (event.detail.selectedOptions.length > 0 && this.state.color == green) {
        this.changeStatus(event.detail.selectedOptions);
      } else if (event.detail.selectedOptions.length == 0 && this.state.color == red) {
        this.changeStatus(event.detail.selectedOptions);
      } else {
        this.handleStoreAudit(this.state.color);
      }
    });
  }

  /**Update the different states of the item when clicked */
  updateItem() {
    this.changeStatus([]);
  }


  /**Displays child asin on page, if enable re-edit is on, show child asin*/
  displayAsin() {
    if (!this.props.enableReEdit) {
      return null;
    }

    return this.props.item.child_asin;
  }

  changeEdited(val) {
    this.setState({edited: val});
  }

  displayEdited() {
    if (!this.props.enableReEdit) {
      return null;
    }

    return this.state.edited ? "Edited" : "";
  }

  render(){
    return(
      <div className="item-div" style={{border: this.state.isSeedCategory ? "solid" : "none"}}>
        <div className="item-container">
          <img className="awsui-util-t-c" 
          onClick={this.updateItem} 
          src={"https://m.media-amazon.com/images/I/" + this.props.item.image_id + ".jpg"}
          />
        </div>
        <div>
          {this.displayEdited()}
        </div>
        <div className="status-bar" style={{background: this.state.color}}>
          <img className="status-img"></img>
        </div>
        <div className="status-bar">
          {this.displayAsin()}
        </div>
        {this.props.enableCollection ?  
          <Multiselect
            className="rejection-reasons"
            filteringType="auto"
            options={this.state.isSeedCategory ? seedOptions : options}
            placeholder="Choose options"
            checkboxes={true}
            selectedOptions={this.state.selectedOptions}
            selectedLabel="Selected"
            onChange={this.handleChange}
          ></Multiselect> : null
        }
        {this.state.isSeedCategory ?
          <div className="seed-category">
            Seed Item
          </div> : null
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/item.jsx